export const mockEvents = [
  {
    id: 'event-1',
    title: 'Hands-on: BESS Commissioning',
    description: 'Practical training on battery storage system commissioning and testing.',
    startsAt: '2026-06-18T09:00:00Z',
    mode: 'IN_PERSON',
    location: 'Nairobi CoE',
    capacity: 30,
    seatsRemaining: 14,
    coEManaged: true
  },
  {
    id: 'event-2',
    title: 'Webinar: Grid-Code Reform Clinic',
    description: 'Q&A session with regulators who have successfully updated their grid codes.',
    startsAt: '2026-06-25T14:00:00Z',
    mode: 'VIRTUAL',
    location: 'Online',
    capacity: 500,
    seatsRemaining: null,
    coEManaged: false
  },
  {
    id: 'event-3',
    title: 'Cohort kickoff: Storage Procurement',
    description: '6-week guided cohort working through real procurement scenarios.',
    startsAt: '2026-07-02T10:00:00Z',
    mode: 'VIRTUAL',
    location: 'Online',
    capacity: 50,
    seatsRemaining: 23,
    coEManaged: true
  }
];
